// client/src/pages/Admin/ProjectManager/components/ProjectStatusBadge.tsx
/**
 * PROJECT STATUS BADGE COMPONENT
 * 
 * Displays a project status with color coding and icon.
 * 
 * @module ProjectManager/Components/ProjectStatusBadge
 */

import React from 'react';
import { ProjectStatus } from '../../../../shared/models/Project';
import {
    formatStatusLabel,
    getStatusColor,
    getStatusIcon
} from '../utils/projectHelpers';

interface ProjectStatusBadgeProps {
    status: ProjectStatus;
    size?: 'sm' | 'md' | 'lg';
    showIcon?: boolean;
    className?: string;
}

export const ProjectStatusBadge: React.FC<ProjectStatusBadgeProps> = ({
    status,
    size = 'md',
    showIcon = true,
    className = ''
}) => {
    const label = formatStatusLabel(status);
    const colorClass = getStatusColor(status);
    const StatusIcon = getStatusIcon(status);

    const sizeClasses = {
        sm: 'text-xs px-2 py-0.5',
        md: 'text-sm px-3 py-1',
        lg: 'text-base px-4 py-1.5'
    };

    return (
        <span
            className={`status-badge ${colorClass} ${sizeClasses[size]} ${className}`}
            role="status"
            aria-label={`Project status: ${label}`}
        >
            {showIcon && <span className="mr-1"><StatusIcon size={14} /></span>}
            <span>{label}</span>
        </span>
    );
};